import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
const baseURL = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}`;
const axiosClient = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.REACT_APP_KEY_AUTHEN}`,
  },
});

axiosClient.interceptors.request.use(
  function (config: AxiosRequestConfig) {
    const access_token = sessionStorage.getItem("access_token");
    if (access_token && config.headers) {
      config.headers
        ? (config.headers.Authorization = `Bearer ${access_token}`)
        : (config.headers = {
            Authorization: `Bearer ${access_token}`,
          });
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  function (response: AxiosResponse) {
    return response.data;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axiosClient;
